var _g, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNexusLogoHorizontal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 372,
    height: 136,
    viewBox: "41 21 186 68",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Nexus logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20, 10)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 70,
    x2: 70,
    y2: 20,
    stroke: "#2D3A8C",
    strokeWidth: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 20,
    x2: 30,
    y2: 70,
    stroke: "#0E7C7B",
    strokeWidth: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70,
    y1: 20,
    x2: 70,
    y2: 70,
    stroke: "#0E7C7B",
    strokeWidth: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 20,
    r: 7,
    fill: "#F4A259"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 70,
    r: 7,
    fill: "#F4A259"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 113,
    y: 67,
    fontFamily: "Helvetica, Arial, sans-serif",
    fontSize: 42,
    fontWeight: 500,
    fill: "#1A1A2E",
    letterSpacing: 1
  }, "nexus")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNexusLogoHorizontal);
export default __webpack_public_path__ + "static/media/nexus-logo-horizontal.e61af190a090b17db744bf0c3493ee21.svg";
export { ForwardRef as ReactComponent };